<template>
    <transition-group name="modal" v-if="isShown" ref="container">
        <div 
            class="modal" 
            tabindex="-1" 
            role="dialog" 
            ref="modal"
            @mousedown.self="onBlur"
            :key="modalKey"
        >
            <div v-bind:class="sizeClasses[size]" class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <slot name="modal-title"></slot>
                        
                        <button type="button" 
                                class="close"  
                                aria-label="Close"
                                @click="hide"
                        ><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <slot name="modal-body">
                            
                        </slot>
                    </div>
                    <div class="modal-footer">
                        <slot name="modal-footer">
                        </slot>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="rootModal"
            class="modal-backdrop show"
            @click="onBlur"
            :key="backdropKey"
        ></div>
    </transition-group>
</template>

<script>
    //Actually a VueDal

    //Based on:
    //https://vuejs.org/v2/examples/modal.html
    
    import {guid} from "../../Util/guid";
    import $ from 'jquery';
    import _ from 'lodash';

    const sizes = {
        small: 'small',
        medium: 'medium',
        large: 'large',
        extraLarge: 'extraLarge',
        
        custom: 'custom'
    };
    
    const sizeClasses = {
        small: 'modal-sm',
        large: 'modal-lg',
        extraLarge: 'modal-xl',

        medium: '',
        custom: ''
    };
    
    export {
        sizes
    }
    
    export default {
        name: "modal",
        created(){
            const vm = this;
            
            vm.modalKey = guid();
            vm.backdropKey = guid();

            document.addEventListener('keyup', event => {
                if(event.key === 'Escape' && vm.isShown && vm.opts.close.onEsc) {
                    vm.hide();
                }
            });
            
        },
        beforeDestroy() {
            //Prevent our modal from becoming a zombie modal by ensuring proper disposal prior to deletion
            const modalElement = this.getModalElement;
            
            if(modalElement){
                modalElement.remove();
            }
        },
        computed: {
            opts() {
                return _.merge({}, this.defaultOptions, this.options);
            }
        },
        data: () => ({
            sizeClasses: sizeClasses,
            isShown: false,
            
            modalKey: '',
            backdropKey: '',
            rootModal: true,
            defaultOptions: {
                close: {    
                    onEsc: true,
                    onBlur: true    
                }
            }
        }),
        methods: {            
            //Using a computed might cause de-sync between active value/cached value
            //this causes the value to not refer to the current this.$refs.container.$el value
            //anymore on a second invocation of the 'show' method
            getModalElement(){
                return this.$refs.container && this.$refs.container.$el;
            },
            show(){
                const vm = this;
                const openModals = $('.modal-content');

                if(openModals.length > 0) {
                    vm.rootModal = false;

                    openModals.append(`<div ${vm.$options._scopeId} class="modal-overlay"></div>`);
                }

                vm.$emit('show');
                vm.isShown = true;

                //Our 'transition' container element will only be available once it's actually shown
                //We'll need to move our modal to the body
                //this is to prevent overlap with other elements

                vm.$nextTick(() => {
                    const el = vm.getModalElement();
                    document.body.appendChild(el);
                    
                    if(vm.rootModal) {
                        document.body.classList.add("modal-open");
                    }
                });

                vm.$emit('shown');
            },
            onBlur(){
                const vm = this;
                
                if(vm.opts.close.onBlur !== false) {
                    vm.hide();
                }
            },
            hide(){
                const vm = this;

                const openModals = $('.modal-content');

                openModals.each((i, modal) => {
                    $(modal).find('.modal-overlay').remove();
                });

                vm.$emit('hide');
                vm.isShown = false;

                if(vm.rootModal) {
                    document.body.classList.remove("modal-open");
                }
                
                vm.$emit('hidden');
            }
        },
        props: {
            size: {
                type: String,
                default: sizes.medium,
                validate: v => {
                    return Object.values(sizes).indexOf(v) !== -1
                }
            },
            customSize: {
                type: Number
            },
            options: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        }
    }
</script>

<style scoped lang="scss" src="./Styles/modal.scss">

</style>
